module.exports = __webpack_public_path__ + "img/investment-history-fullGrey.a3915258.svg";